import React, { useContext } from "react";
import {
  ProfileFirstPage,
  EditProfile,
  ChangePassword,
  UsersSetting,
  HomeEdit,
  Setting,
  DeviceMine,
  DeviceInfo,
} from "./";
import { ContactUs, PrivacyPolicy, HowToUse } from "../";
import { ProfileSection } from "../../context/ProfileContext";

const Profile = (props) => {
  const { profilePage } = useContext(ProfileSection);
  console.log(props);
  return (
    <div style={{ minHeight: "90vh" }}>
      {profilePage.firstPage && <ProfileFirstPage props22={props} />}
      {profilePage.settingPage && <EditProfile />}
      {profilePage.changePassPage && <ChangePassword />}
      {profilePage.usersSetting && <UsersSetting />}
      {profilePage.homeEdit && <HomeEdit />}
      {profilePage.setting && <Setting />}
      {profilePage.contactUs && <ContactUs />}
      {profilePage.howUse && <HowToUse />}
      {profilePage.privacy && <PrivacyPolicy />}
      {profilePage.deviceMine && <DeviceMine />}
      {profilePage.deviceInfo && <DeviceInfo />}
    </div>
  );
};

export { Profile };
